import '@ant-design/v5-patch-for-react-19'
import React from 'react'
import { createRoot } from 'react-dom/client'

import App from './App'
import { installPhonePickerKeyboardGuard } from './components/responsive'

// On a phone, keep the soft keyboard from covering date picker calendars
installPhonePickerKeyboardGuard()

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element not found')
}

createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
